export default __webpack_public_path__ + "static/media/6.b61b8c5c.png";